import { render, staticRenderFns } from "./GoToTopButton.vue?vue&type=template&id=c978f9f0&"
import script from "./GoToTopButton.vue?vue&type=script&lang=js&"
export * from "./GoToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./GoToTopButton.vue?vue&type=style&index=0&id=c978f9f0&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports